export default __webpack_public_path__ + "static/media/hot-off-the-press.7ceff89b.jpg";